<template>
  <div class="selection"
       :class="{'selection--preloading': preloading }"
  >
    <div class="selection__options"
         v-tooltip="!title"
    >
      <span class="selection__options-text" v-if="quickFilter">
        {{ title }}
      </span>

      <div v-else
           v-for="option in mappedValues"
           :key="option[valueKey]"
      >
      <span :class="{'badge badge--default': multiple }">
        <slot name="output" v-bind="{option}">
          {{ option[titleKey] }}
        </slot>

        <i v-if="canRemove"
           class="ms-2 icon-times"
           @mouseup.stop="remove(option)"
        />
      </span>
      </div>
    </div>

    <div v-if="count && count > 5" class="selection__count">
      <span class="badge badge--default badge--count">
        {{ count }}
      </span>
    </div>
  </div>
</template>
<script setup>
import {computed} from "vue";

const LIMIT = 5;
const emit = defineEmits(['remove']);
const props = defineProps({
  options: Array,
  values: Array,
  canRemove: Boolean,
  multiple: Boolean,
  valueKey: String,
  titleKey: String,
  preSelection: Object,
  preloading: Boolean,
  quickFilter: Boolean,
});

const mappedValues = computed(() => {
  if (props.preSelection && props.preSelection.items.length) {
    return props.preSelection.items;
  }

  return [...props.values].splice(0, LIMIT).map((value) => {
    let option = props.options.find(opt => opt[props.valueKey].toString() === value.toString());
    if (!option) {
      option = {};
      option[props.valueKey] = value;
      option[props.titleKey] = value;
    }

    return option;
  })
});

const title = computed(() => {
  const list = mappedValues.value.map(value => value[props.titleKey]).join(', ');

  return `${list}${count.value && count.value > LIMIT ? (props.quickFilter ? '...' : '...(' + count.value + ')') : ''}`
});

const count = computed(() => {
  if (props.preSelection && props.preSelection.items.length) {
    return props.preSelection.count;
  }

  return props.values.length;
})

function remove(option) {
  emit('remove', option[props.valueKey]);
}
</script>
<style lang="scss" scoped>
@import "@/css/functions";
@import "@/css/variables";

.selection {
  width: 100%;
  display: flex;
  align-items: center;
  gap: spacing(2);
  justify-content: space-between;
  padding: spacing(2.5) 0;

  &--preloading {
    opacity: .5;
  }

  &__options {
    display: flex;
    align-items: center;
    gap: spacing(2);
    width: 100%;
    font-size: fontSize(5);
    overflow: hidden;

    &-text {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: themeColor('neutral-800');
    }
  }
}
</style>